import React from 'react'
import PropTypes from 'prop-types'

function LinkButton (props) {
  const buttonClass = prop => prop ? 'btn-' + prop : null

  const classNames = [
    'btn',
    buttonClass(props.color),
    buttonClass(props.size),
    buttonClass(props.width)
  ]

  return (
    <a href={props.href} className={classNames.join(' ')}>
      {props.text}
    </a>
  )
}

LinkButton.defaultProps = {
  color: 'primary',
  href: '#'
}

LinkButton.propTypes = {
  /**
     * Button text
     */
  text: PropTypes.string.isRequired,
  /**
     * Color of the button<br>
     * Colors: 'primary', 'white', 'bordered'
     */
  color: PropTypes.string,
  /**
     * Size of the button<br>
     * Sizes: 'default', 'small'
     */
  size: PropTypes.string,
  /**
     * Width of the button<br>
     * Sizes: 'default', 'wide', 'full'
     */
  width: PropTypes.string,
  /**
     * Link HREF attribute
     */
  href: PropTypes.string
}

export default LinkButton
